import React from 'react';

/**
 * Component to display an "up arrow" svg icon
 * @param {*} props - Generic parameter to pass along any desired props to the component
 */

const SvgUpArrowIcon = (props) => (
  <svg viewBox="0 0 22 22" width="1em" height="1em" {...props} id="UpArrowIcon">
    <path
      d="M17.89 7.02h-4.83V22h-4.4V7.02H3.82L10.85 0l7.04 7.02z"
      fill="currentColor"
    />
  </svg>
);

export default SvgUpArrowIcon;
